import { CAT_INFORMATION_SOURCES } from 'App/utils/Collections';
import { FT_SINGLE } from '../FilterTypes';

const SPLITTABLE_HINT = 'You can type multiple values separated by comma, semicolon, or space.';

const groups = {
  general: {
    name: 'General',
    groupOrderIndex: 0,
  },
};
export default {
  category: CAT_INFORMATION_SOURCES,
  filters: [
    {
      id: 'numberOfSnapshots',
      label: 'Number Of Snapshots',
      type: FT_SINGLE,
      group: groups.general,
      hint: '',
    },
    {
      id: 'statusCode',
      label: 'Status Code',
      type: FT_SINGLE,
      group: groups.general,
      hint: SPLITTABLE_HINT,
      useNASearch: true,
      naProp: 'exists[statusCode]',
      splittable: true,
    },
  ],
  searchBarProp: 'url',
};
